import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log('Newsletter subscription:', email);
    setEmail('');
  };

  return (
    <footer className="bg-gradient-to-b from-nvidia-dark-800 to-nvidia-dark pt-20 pb-10">
      <div className="container mx-auto px-6">
        {/* Newsletter Section */}
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4">Stay ahead in the AI shift with <span className="text-nvidia-green">clear, practical insight</span> <span className="text-orixon-orange">and action.</span></h2>
          <p className="text-nvidia-gray-400 mb-8">
            Get the occasional note from Orixon—field learnings, patterns, and product news. No fluff, just what we’ve seen work.
          </p>
          <form onSubmit={handleSubmit} className="max-w-md mx-auto flex gap-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your e-mail"
              className="flex-1 px-4 py-2 rounded-lg bg-nvidia-dark-700 border border-nvidia-dark-600 focus:border-nvidia-green focus:outline-none text-white placeholder-nvidia-gray-500"
              required
            />
            <button
              type="submit"
              className="bg-nvidia-green text-black px-6 py-2 rounded-lg font-semibold hover:bg-opacity-90 transition-colors ring-0 hover:ring-2 hover:ring-orixon-orange"
            >
              Subscribe
            </button>
          </form>
        </div>

        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Navigation Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-nvidia-gray-400 hover:text-nvidia-green transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-nvidia-gray-400 hover:text-nvidia-green transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/docs" className="text-nvidia-gray-400 hover:text-orixon-orange transition-colors">
                  Docs
                </Link>
              </li>
              
              <li>
                <Link to="/blog" className="text-nvidia-gray-400 hover:text-nvidia-green transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-nvidia-gray-400 hover:text-nvidia-green transition-colors"
                >
                  YouTube
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-nvidia-green transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-nvidia-green transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Get In Touch</h3>
            <p className="text-nvidia-gray-400 mb-4">
              Contact us today to see the power of AI in action!
            </p>
            <ul className="space-y-2">
              <li className="flex items-start text-nvidia-gray-400">
                <FaMapMarkerAlt className="mr-2 text-orixon-orange mt-1" />
                <span>
                  1621 CENTRAL AVE #59403<br />
                  CHEYENNE, WY, 82001, USA
                </span>
              </li>
              <li className="flex items-center text-nvidia-gray-400">
                <FaPhone className="mr-2 text-orixon-orange" />
                +1 (202) 703-3574
              </li>
              <li className="flex items-center text-nvidia-gray-400">
                <FaEnvelope className="mr-2 text-orixon-orange" />
                contact@orixon.tech
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Stay Connected</h3>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-nvidia-dark-700 flex items-center justify-center text-nvidia-gray-400 hover:text-orixon-orange transition-colors border border-nvidia-dark-600 hover:border-orixon-orange"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-nvidia-dark-700 flex items-center justify-center text-nvidia-gray-400 hover:text-orixon-orange transition-colors border border-nvidia-dark-600 hover:border-orixon-orange"
              >
                <FaTwitter />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-nvidia-dark-700 flex items-center justify-center text-nvidia-gray-400 hover:text-orixon-orange transition-colors border border-nvidia-dark-600 hover:border-orixon-orange"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-nvidia-dark-700 flex items-center justify-center text-nvidia-gray-400 hover:text-orixon-orange transition-colors border border-nvidia-dark-600 hover:border-orixon-orange"
              >
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center pt-8 border-t border-nvidia-dark-600">
          <p className="text-nvidia-gray-500">
            &copy; Orixon Technology. All Rights Reserved {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
